import { getStore as getListViewStore } from 'owa-mail-list-store/lib/store/Store';
import { showMailItemContextMenu } from 'owa-mail-list-actions/lib/actions/itemContextMenuActions';
import { getAnchorForContextMenu } from 'owa-positioning';
import MailListContextMenuSource from 'owa-mail-list-store/lib/store/schema/MailListContextMenuSource';
import * as mailListSelectionActionsV2 from 'owa-mail-actions/lib/mailListSelectionActions';
import MailListContextMenuType from 'owa-mail-list-store/lib/store/schema/MailListContextMenuType';
import { createLazyOrchestrator } from 'owa-bundling';

// Orchestrator to open a mail list item part context menu on relevant item part(s)
export default createLazyOrchestrator(
    mailListSelectionActionsV2.onItemPartContextMenu,
    'clone_mailListItemExpansionOrchestrator',
    actionMessage => {
        const expansionState = getListViewStore().expandedConversationViewState;
        const selectedItems = expansionState.selectedNodeIds;

        // Select the item upon right click if
        // - the item that is clicked on is not selected yet
        if (!selectedItems || selectedItems.indexOf(actionMessage.nodeId) == -1) {
            mailListSelectionActionsV2.singleSelectItemPart(
                expansionState.expandedRowKey,
                actionMessage.nodeId,
                actionMessage.allNodeIds,
                actionMessage.tableViewId
            );
        }
        showMailItemContextMenu(
            getAnchorForContextMenu(actionMessage.evt),
            MailListContextMenuType.All,
            MailListContextMenuSource.MailListItemPart
        );
    }
);
